import {State, Action, Selector, StateContext} from '@ngxs/store';
import {AddAlerts, GetAlerts, ResolveAlert} from './alert.actions';
import {tap} from 'rxjs/operators';
import {AlertService} from '@shared/service/alert/alert.service';
import {LoggerService} from '@app/service/logger/logger.service';
import {ToastService} from '@app/service/util/toast.service';
import {Injectable} from '@angular/core';
import {Alert} from '@shared/interfaces';

export interface AlertStateModel {
  alerts: Partial<Alert>[];
}

@State<AlertStateModel>({
  name: 'alert',
  defaults: {
    alerts: []
  }
})
@Injectable()
export class AlertState {
  constructor(private alertService: AlertService, private logger: LoggerService, private toastr: ToastService) {
  }

  @Selector()
  static getAlertData(state: AlertStateModel) {
    return state.alerts;
  }

  @Action(AddAlerts)
  addAlert({payload}: AddAlerts) {
    // TODO: There may be something funky here because I removed -- {getState, patchState}: StateContext<AlertStateModel>
    return this.alertService.createAlert(payload);
  }

  @Action(ResolveAlert)
  resolveAlert({getState, patchState}: StateContext<AlertStateModel>, {payload}: ResolveAlert) {
    return this.alertService.resolveAlert(payload.alertId)
      .then(() => {
        let alerts = getState().alerts;
        if (alerts) {
          alerts = alerts.filter(alert => alert.id !== payload.alertId);
        }
        patchState({
          alerts
        });
        return this.toastr.success('Alert marked as read!');
      })
      .catch(err => {
        return this.toastr.error('An error occurred while trying to resolve alert', err);
      });
  }

  @Action(GetAlerts)
  getAlertsData({patchState}: StateContext<AlertStateModel>) {
    return this.alertService.getAlertData()
      .pipe(tap((result) => {
        patchState({
          alerts: result,
        });
      }));
  }
}
